import styled from 'styled-typed'

export const FieldSpacingWrapper = styled.div`
    margin-bottom: 1rem;
`

export default FieldSpacingWrapper
